interface LogoProps {
  size?: number;
  className?: string;
  showText?: boolean;
  textClassName?: string;
}

export default function Logo({ size = 36, className = '', showText = false, textClassName = '' }: LogoProps): React.ReactElement {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        fill="none"
        width={size}
        height={size}
        className="shrink-0"
      >
        <rect width="32" height="32" rx="8" fill="currentColor" className="text-primary" />
        <path
          d="M6 15 L16 6 L26 15"
          stroke="white"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <rect x="9" y="14" width="14" height="12" rx="1.5" fill="white" opacity="0.25" />
        <rect x="13" y="19" width="6" height="7" rx="1" fill="white" />
      </svg>
      {showText && (
        <span className={`font-bold text-lg leading-tight ${textClassName}`}>
          SGI
        </span>
      )}
    </div>
  );
}
